import { render, staticRenderFns } from "./room-list.vue?vue&type=template&id=c48373ea&scoped=true"
import script from "./room-list.vue?vue&type=script&lang=js"
export * from "./room-list.vue?vue&type=script&lang=js"
import style0 from "./room-list.vue?vue&type=style&index=0&id=c48373ea&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c48373ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c48373ea')) {
      api.createRecord('c48373ea', component.options)
    } else {
      api.reload('c48373ea', component.options)
    }
    module.hot.accept("./room-list.vue?vue&type=template&id=c48373ea&scoped=true", function () {
      api.rerender('c48373ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hotel/room-list.vue"
export default component.exports